package com.eladfinish.bible.contest.screens.search.usecases

import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.input.TextFieldValue

class InsertTextAtCursorUseCase {

    operator fun invoke(
        current: TextFieldValue,
        textToInsert: String,
    ): TextFieldValue {
        val start = current.selection.min
        val end = current.selection.max

        val newText = current.text.replaceRange(
            startIndex = start,
            endIndex = end,
            replacement = textToInsert,
        )

        val newCursor = start + textToInsert.length

        return current.copy(
            text = newText,
            selection = TextRange(newCursor),
        )
    }
}
